"use strict";

exports.__esModule = true;
exports.pdfViewerReducer = exports.initialState = exports.SET_ZOOM = exports.SET_IS_MOBILE = exports.SET_FULLSCREEN = exports.SET_CURRENT_PAGE = exports.RESET_STATE = exports.PAGE_RENDERED = exports.FILE_LOAD_SUCCESS = exports.FILE_LOAD_PROGRESS = exports.FILE_LOAD_ERROR = exports.DOCUMENT_RENDERED = exports.DOCUMENT_LOADED = void 0;

var _helpers = require("./helpers");

const RESET_STATE = 'RESET_STATE';
exports.RESET_STATE = RESET_STATE;
const SET_ZOOM = 'SET_ZOOM';
exports.SET_ZOOM = SET_ZOOM;
const SET_FULLSCREEN = 'SET_FULLSCREEN';
exports.SET_FULLSCREEN = SET_FULLSCREEN;
const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
exports.SET_CURRENT_PAGE = SET_CURRENT_PAGE;
const SET_IS_MOBILE = 'SET_IS_MOBILE';
exports.SET_IS_MOBILE = SET_IS_MOBILE;
const FILE_LOAD_SUCCESS = 'FILE_LOAD_SUCCESS';
exports.FILE_LOAD_SUCCESS = FILE_LOAD_SUCCESS;
const FILE_LOAD_PROGRESS = 'FILE_LOAD_PROGRESS';
exports.FILE_LOAD_PROGRESS = FILE_LOAD_PROGRESS;
const FILE_LOAD_ERROR = 'FILE_LOAD_ERROR';
exports.FILE_LOAD_ERROR = FILE_LOAD_ERROR;
const DOCUMENT_LOADED = 'DOCUMENT_LOADED';
exports.DOCUMENT_LOADED = DOCUMENT_LOADED;
const PAGE_RENDERED = 'PAGE_RENDERED';
exports.PAGE_RENDERED = PAGE_RENDERED;
const DOCUMENT_RENDERED = 'DOCUMENT_RENDERED';
exports.DOCUMENT_RENDERED = DOCUMENT_RENDERED;
const initialState = {
  currentPage: 1,
  numPages: null,
  pagesRendered: 0,
  zoom: 100,
  fullScreen: false,
  progress: 0,
  error: false,
  loading: false,
  loaded: false,
  ready: false,
  pdfDocument: null,
  pageOffsets: null,
  pageScaleFactor: null,
  blob: null,
  objectURL: null,
  isMobile: (0, _helpers.isMobileBreakpoint)()
};
exports.initialState = initialState;

const pdfViewerReducer = (state, action) => {
  switch (action.type) {
    case RESET_STATE:
      {
        return { ...initialState
        };
      }

    case FILE_LOAD_SUCCESS:
      {
        const {
          blob,
          zoom,
          currentPage
        } = action.payload;
        return { ...state,
          blob,
          progress: 50,
          error: false,
          zoom,
          currentPage
        };
      }

    case FILE_LOAD_PROGRESS:
      {
        const {
          progress
        } = action.payload;
        return { ...state,
          progress
        };
      }

    case FILE_LOAD_ERROR:
      {
        return { ...state,
          error: true
        };
      }

    case DOCUMENT_LOADED:
      {
        const pdfDocument = action.payload;
        return { ...state,
          loading: false,
          loaded: true,
          progress: 50,
          pdfDocument,
          numPages: pdfDocument._pdfInfo.numPages
        };
      }

    case PAGE_RENDERED:
      {
        const pagesRendered = state.pagesRendered + 1;
        return { ...state,
          pagesRendered,
          progress: 50 + pagesRendered / state.numPages * 50
        };
      }

    case DOCUMENT_RENDERED:
      {
        return { ...state,
          ready: true,
          loading: false
        };
      }

    case SET_ZOOM:
      {
        const zoom = action.payload;
        return { ...state,
          previousZoom: state.zoom,
          zoom
        };
      }

    case SET_FULLSCREEN:
      {
        const fullScreen = action.payload;
        return { ...state,
          fullScreen
        };
      }

    case SET_CURRENT_PAGE:
      {
        const currentPage = action.payload;
        return { ...state,
          currentPage
        };
      }

    case SET_IS_MOBILE:
      {
        const isMobile = action.payload;
        return { ...state,
          isMobile
        };
      }

    default:
      {
        return state;
      }
  }
};

exports.pdfViewerReducer = pdfViewerReducer;